import {
  TableRow,
  Stack,
  Chip,
  Typography,
  TableContainer,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { HubCardStack } from "../../components";
// import { HubCardStack } from "../../components";

export const StyledStack = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "4px 24px",
  backgroundColor: theme.palette.hubColors.greyLighter,
}));

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => !["isSelected"].includes(prop),
})(({ isSelected, theme }) => ({
  ...(!isSelected
    ? {
        backgroundColor: theme.palette.hubColors.greyLighter,
      }
    : {}),
  "&:hover": {
    backgroundColor: !isSelected
      ? theme.palette.hubColors.greyLighter
      : "inherit",
    cursor: "default",
  },
}));

export const StyledSubStack = styled(Stack)(({ theme }) => ({
  // padding: "15px",
  boxSizing: "border-box",
  // background: `linear-gradient(to bottom, rgba(0,0,0,0.15), ${theme.palette.hubColors.greyLightest} 7px)`,
}));

export const StyledHubCardStack = styled(Stack, {
  shouldForwardProp: (prop) => !["disableMx"].includes(prop),
})(({ disableMx, theme }) => ({
  gap: "25px",
  width: "100%",
  height: "100%",
  padding: "50px 25px",
  background: `linear-gradient(to bottom, rgba(0,0,0,0.15), ${theme.palette.hubColors.white} 4px)`,
  ...(disableMx ? {} : { margin: "auto" }),
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  fontSize: 10,
  fontWeight: 600,
  borderRadius: 2,
  backgroundColor: theme.palette.hubColors.redMainTransparent,
  color: theme.palette.hubColors.redMain,
  padding: "1px",
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: 10,
  fontWeight: 600,
  color: theme.palette.hubColors.redMain,
}));

export const StyledContainer = styled(Stack)(({ theme }) => ({
  overflow: "auto",
  height: "100%",
  position: "relative",
  "::-webkit-scrollbar": {
    display: "none",
  },
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  backgroundColor: theme.palette.hubColors.white,
  overflow: "visible",
  minHeight: "fit-content",
  height: "100%",
  margin: "50px auto",
  maxWidth: "1000px",
  width: "1000px",
  minWidth: "1000px",
  ".MuiTableCell-root": { borderRight: "0 !important" },
}));
